import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Input, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import { textureOptions, typeOptions } from './constants'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const NutSeedButtersPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Type: item.Type,
    Size: item.Size,
    Texture: item.Texture,
    OtherTexture: item.OtherTexture,
  })

  const methods = useFormContext()
  const { setSelectReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { Type, Size, Texture, OtherTexture } = item
      setPackaging({ Type, Size, Texture, OtherTexture })
    }
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Type"
            defaultValue={{ label: packaging.Type, value: packaging.Type }}
            options={typeOptions}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({ ...packaging, Type: selected.value })
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
            isDisabled={isDisabled}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Type"
            message={'⚠ Please select a Type'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </FormGroup>
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="Size"
            defaultValue={packaging.Size}
            control={methods.control}
            rules={{
              required: '⚠ Please enter product size',
              maxLength: { value: 5, message: '⚠ Size exceeds 5 characters' },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => isNotNumericDecimal(e.key) && e.preventDefault()}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Size"
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </FormGroup>
      </Col>

      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Texture {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Texture"
            defaultValue={{
              label: packaging.Texture,
              value: packaging.Texture,
            }}
            options={textureOptions}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({ ...packaging, Texture: selected.value })
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
            isDisabled={isDisabled}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Texture"
            message={'⚠ Please select a Texture'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </FormGroup>

        {packaging.Texture === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Texture (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="OtherTexture"
              defaultValue={packaging.OtherTexture}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                required: '⚠ Other Texture is required',
                maxLength: {
                  value: 15,
                  message: '⚠ Other Texture exceeds 15 characters.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <ErrorMessage
              errors={methods.errors}
              name="OtherTexture"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </FormGroup>
        )}
      </Col>
    </Row>
  )
}

NutSeedButtersPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default NutSeedButtersPackageReview
